import React from 'react';
import dessert from '../../images/fruits.jpg';
import khinka from '../../images/khinka.PNG';
import khinkali from '../../images/khinkali.PNG';
import lamb from '../../images/p-sauce.jpg';

import dressedtable from '../../images/dressed-table.PNG';
import p17 from '../../images/p17.png';
import dessert2 from '../../images/ovalbread.jpg';
import cheese from '../../images/p10.PNG';
import bbqonskewer from '../../images/p13.PNG';
import GaleryItem from './GaleryItem';

import servingfood from '../../images/servingfood.jpg';
import servingcheese from '../../images/servingcheese.jpg';

import oldtbilisi from '../../images/oldtbilisi-restaurant.jpg';
import or1 from '../../images/or-1.jpg';
import or2 from '../../images/or-2.jpg';
import or3 from '../../images/or-3.jpg';
import or4 from '../../images/or-4.jpg';
import or5 from '../../images/or-5.jpg';
import or6 from '../../images/or-6.jpg';
import or7 from '../../images/or-7.jpg';
import or9 from '../../images/or-9.jpg';

import f1 from '../../images/f-1.jpg';
import f2 from '../../images/f-2.jpg';
import f3 from '../../images/f-3.jpg';
import f4 from '../../images/f-4.jpg';

import x1 from '../../images/drinks.jpg';
import x2 from '../../images/champx.jpg';
import x3 from '../../images/breadx.jpg';

import {useTranslation } from "react-i18next"; 

function Galery() {
    const { t, i18n } = useTranslation();
    
    return (
        <section id="gallery" className="gallery">
            <div className="container" >
                <div className="section-title">
                    <h2>{t("gallery")} <i className="no-pointer far fa-images"></i></h2>
                    <p>{t("gallery-title")} <span className="text-old">Old Tbilisi</span></p>
                </div>
            </div>
            <div className="container-fluid"  >
                <div className="row no-gutters">  
                    
                    <GaleryItem img={oldtbilisi} title="Old Tbilisi Restaurant" desc="Come and eat a delicous Georgian meal."/>
                    <GaleryItem img={or1} title="" desc=""/>
                    <GaleryItem img={dressedtable} title="Event at Old Tbilisi" desc="Dressed table with Khachapuri, assorted cheese and meat, and Georgian drinks."/>
            
                    <GaleryItem img={or4} title="" desc=""/>
                    <GaleryItem img={servingcheese} title="Old Tbilisi assorted cheese" desc="Assorted cheese served on a skewer."/>
                    <GaleryItem img={servingfood} title="Old Tbilisi assorted meat" desc="Assorted meat grilled on the barbecue, served on a skewer. Comes with a salade and potatoes."/>
                      
                    <GaleryItem img={khinka} title="Sinkali soup" desc=""/>
                    <GaleryItem img={bbqonskewer} title="Barbecue on a skewer" desc="Delicious meat grilled on the barbecue and served on a skewer."/>
                    <GaleryItem img={p17} title="" desc=""/> 

                    <GaleryItem img={or5} title="Tradition bake oven" desc="Discover our tradition bake oven inside our restaurant."/>
                    <GaleryItem img={or3} title="Traditional Georgian decoration" desc="Discover our tradition Georgian decoration inside our restaurant."/>
                    <GaleryItem img={or2} title="Serving clients at Old Tbilisi" desc="It's always a pleasure to discuss with our clients"/>
                      
                    <GaleryItem img={or6} title="" desc=""/>
                    <GaleryItem img={or7} title="" desc=""/>
                    <GaleryItem img={or9} title="" desc=""/>  
                    
                    <GaleryItem img={f2} title="" desc=""/>
                    <GaleryItem img={f3} title="" desc=""/> 
                    <GaleryItem img={f1} title="" desc=""/>     



                    <GaleryItem img={f4} title="Shkmeruli" desc="Tender chicken meat in a clay pot prepared with garlic and cream sauce"/>
                    <GaleryItem img={dessert} title="Dessert" desc=""/>   
                    <GaleryItem img={cheese} title="Georgian cheese" desc="Multiple varieties of delicious Georgian cheese served on a skewer."/>        
              
                    <GaleryItem img={x1} title="" desc=""/>
                    <GaleryItem img={x3} title="" desc=""/>     
                    <GaleryItem img={x2} title="" desc=""/> 

                    <GaleryItem img={khinkali} title="Khinkali" desc=""/> 
                    <GaleryItem img={lamb} title="Lamb" desc=""/>
                    <GaleryItem img={dessert2} title="Dessert" desc=""/> 
            </div>
        </div>
    </section>
    )
}

export default Galery;
